import axios, { AxiosRequestConfig } from "axios";
import { getCookie } from "utils/setCookie";

export const getListUser = async (
  page: number = 1,
  limit: number = 10,
  search?: string
): Promise<any> => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });

  if (search) {
    params.append("search", search);
  }

  const url = `${process.env.REACT_APP_AJAX_URL}user/list?${params.toString()}`;

  try {
    const axiosConfig = {
      headers: {
        "X-Authorization": getCookie("session"),
      },
    };

    const response = await axios.get(url, axiosConfig);
    return response;
  } catch (error) {
    throw new Error("Failed to fetch user data");
  }
};

export const getListUserWhenAdd = async (
  page: number = 1,
  limit: number = 10,
  search?: string
): Promise<any> => {
  const url = `${process.env.REACT_APP_AJAX_URL}user/list?page=${page}&limit=${limit}&search=${search}`;

  try {
    const axiosConfig = {
      headers: {
        "X-Authorization": getCookie("session"),
      },
    };

    const response = await axios.get(url, axiosConfig);
    return response;
  } catch (error) {
    throw new Error("Failed to fetch user data");
  }
};

export const getUserById = async (id: string): Promise<any> => {
  const url = process.env.REACT_APP_AJAX_URL + `user/detail/${id}`;
  try {
    const axiosConfig = {
      headers: {
        "X-Authorization": getCookie("session"),
      },
    };

    return await axios.get(url, axiosConfig);
  } catch (error) {
    throw new Error("Failed to fetch user data");
  }
};

export const unFollow = async (partner_id: string): Promise<any> => {
  const requestData = { partner_id };
  const url = process.env.REACT_APP_AJAX_URL + `user/un-follow`;
  try {
    const axiosConfig = {
      headers: {
        "X-Authorization": getCookie("session"),
      },
    };
    return await axios.post(url, requestData, axiosConfig);
  } catch (error) {
    throw new Error("Failed to fetch user data");
  }
};

export const uploadAvatar = async (
  file: File,
  headers: AxiosRequestConfig["headers"]
): Promise<any> => {
  try {
    const formData = new FormData();
    formData.append("file[]", file);

    const config: AxiosRequestConfig = {
      method: "post",
      url: `${process.env.REACT_APP_AJAX_UPLOAD_URL_BASE}/upload-file?callback=${process.env.REACT_APP_AJAX_URL}media/create`,
      headers,
      data: formData,
    };

    const response = await axios.request(config);
    if (response.data && response.data[0] && response.data[0].src) {
      return response.data[0].src;
    } else {
      throw new Error("Upload failed: Invalid response");
    }
  } catch (error) {
    throw new Error(`Upload failed: ${error.message}`);
  }
};

export const uploadUser = async (
  _id: string,
  bio: string,
  link: string,
  user_avatar: string,
  display_name: string,
  user_address: string,
  official_status: string,
  phone_number: string,
  badge: string,
  user_role: string
): Promise<any> => {
  const requestData = {
    _id,
    bio,
    user_avatar,
    display_name,
    user_address,
    official_status,
    link,
    phone_number,
    badge,
    user_role,
  };
  const url = process.env.REACT_APP_AJAX_URL + `user/admin/update/user/${_id}`;
  try {
    const axiosConfig = {
      headers: {
        "X-Authorization": getCookie("session"),
      },
    };
    return await axios.patch(url, requestData, axiosConfig);
  } catch (error) {
    throw new Error("Failed to fetch user data");
  }
};

export const deleteUser = async (id: string): Promise<any> => {
  const url = `${process.env.REACT_APP_AJAX_URL}user/delete/${id}`;
  try {
    const axiosConfig = {
      headers: {
        "X-Authorization": getCookie("session"),
      },
    };

    return await axios.delete(url, axiosConfig);
  } catch (error) {
    throw new Error("Failed to fetch call one-one data");
  }
};
